import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EmojiSlightlySadIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 23c6.08 0 11-4.92 11-11S18.08 1 12 1 1 5.92 1 12s4.92 11 11 11zm0-2a9 9 0 11.001-18.001A9 9 0 0112 21zm.1-9c2.8 0 4.8 1.56 5.79 3.55.25.49.05 1.09-.45 1.34a.993.993 0 01-1.34-.45c-.69-1.37-2.06-2.45-4.01-2.45-2.11 0-3.51 1.06-4.21 2.45-.25.49-.85.69-1.34.45a1.01 1.01 0 01-.45-1.34c1-2.01 3.04-3.55 5.99-3.55h.02zM8 10.5c.83 0 1.5-.67 1.5-1.5S8.83 7.5 8 7.5 6.5 8.17 6.5 9s.67 1.5 1.5 1.5zM17.5 9c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
EmojiSlightlySadIcon.isCarinaIcon = true;
export default EmojiSlightlySadIcon;
